module.exports = __webpack_public_path__ + "img/logo_interno.2581fd7b.jpg";